<div class="col-sm-2 resident-notifications-filter">
    <div class="parcels-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="parcels-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="unreadCheckbox" #unreadCheckbox (change)="changeFilter()">
                <label for="unreadCheckbox"><svg-checked></svg-checked></label>
                <span>Unread</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/email-merge/resident-notifications-filter/resident-notifications-filter.component.html